import React, { useEffect, useState, FormEvent } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Formulario, { FormField } from "../../../../components/Formulario";
import { getModeloById, updateModelo } from "../../../../api/modeloApi";
import { getFabricantes } from "../../../../api/fabricanteApi";
import { Box, Typography } from "@mui/material";
import { Fabricante } from "../../../../types/acao";

const EditarModelo: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [descricaoModelo, setDescricaoModelo] = useState<string>("");
  const [descricaoFabricante, setDescricaoFabricante] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const [updating, setUpdating] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchModeloEFabricante = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("Token não encontrado");
        }

        const modeloData = await getModeloById(token, id!);
        setDescricaoModelo(modeloData.descricao_modelo);

        const fabricantesData = await getFabricantes(token);
        const fabricante = fabricantesData.find(
          (fabricante: Fabricante) => fabricante.id === modeloData.id_fabricante
        );

        if (fabricante) {
          setDescricaoFabricante(fabricante.descricao_fabricante);
        }
      } catch (error) {
        toast.error("Erro ao buscar modelo ou fabricante!");
        console.error("Erro ao buscar modelo ou fabricante:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchModeloEFabricante();
  }, [id]);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setUpdating(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado");
      }

      await updateModelo(token, id!, {
        descricao_modelo: descricaoModelo,
      });
      toast.success("Modelo atualizado com sucesso!");
      navigate("/modelos");
    } catch (error) {
      toast.error("Erro ao atualizar modelo!");
      console.error("Erro ao atualizar modelo:", error);
    } finally {
      setUpdating(false);
    }
  };

  const handleBack = () => {
    navigate("/modelos");
  };

  const fields: FormField[] = [
    {
      label: "Descrição do Modelo",
      type: "text",
      value: descricaoModelo,
      required: true,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setDescricaoModelo(e.target.value),
    },
  ];

  return (
    <>
      <Formulario
        title="Editar Modelo"
        fields={fields}
        onSubmit={handleSubmit}
        onBack={handleBack}
        loading={loading || updating}
      />
      {!loading && (
        <Box sx={{ mt: 2, p: 3 }}>
          <Typography variant="body1">Fabricante Cadastrado:</Typography>
          <Typography variant="h6">{descricaoFabricante}</Typography>
        </Box>
      )}
    </>
  );
};

export default EditarModelo;
